<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-clipboard-list</v-icon>{{ item['uuid'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <SetupDefinitionForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <template>
      <div class="setupdefinitionsub-list">
        <Toolbar
          :handle-add="() => addHandlerSub('SetupDefinitionSub',item)"
        />


        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex sm12>
              <h1>{{ $t('profile.setupdefinition.definitionssub') }}</h1>
            </v-flex>
            <v-flex lg12>
              <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                <SetupDefinitionSubFilterForm
                  ref="filterForm"
                  :values="filters"
                  slot="filter"
                />
              </DataFilter>

              <br />

              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="itemsSub"
      :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                :loading="isLoading"
                :loading-text="$t('global.loading')"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                item-key="@id"
                show-select
                @update:options="onUpdateOptions"
@click:row="editHandlerSubEvent"
              >

                <ActionCell
                  slot="item.action"
                  slot-scope="props"
                  :handle-edit="() => editHandlerSub(item,'SetupDefinitionSub',props.item)"
                ></ActionCell>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import SetupDefinitionForm from '../../components/setupdefinition/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import SetupDefinitionSubFilterForm from '../../components/setupdefinitionsub/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'SetupDefinition';

export default {
  name: 'SetupDefinitionUpdate',
  servicePrefix,
  mixins: [ListMixin,UpdateMixin],
  components: {
    Loading,
    Toolbar,
    SetupDefinitionForm,
    ActionCell,
    SetupDefinitionSubFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.setupdefinition.tool'), value: 'tool.name' },
        { text: this.$t('profile.setupdefinition.material'), value: 'material.name' },
        { text: this.$t('profile.setupdefinition.nozzle'), value: 'nozzle.name' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'setupDefinition' : this.$route.params.id,
      },
      selected: []
    };
  },
  computed: {
    ...mapFields('setupdefinition', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('setupdefinition', ['find']),
    ...mapGetters('setupdefinitionsub', {
      itemsSub: 'list'
    }),
    ...mapFields('setupdefinitionsub', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })

  },

  methods: {
    ...mapActions('setupdefinition', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    ...mapActions('setupdefinitionsub', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    editHandlerSubEvent(value) {
      this.editHandlerSub(this.item,'SetupDefinitionSub',value);
    }
  }
};
</script>
